import * as React from "react";

import { Drawer, DrawerProps } from "./drawer";

export interface DrawerViewModel extends DrawerProps {}

interface DrawerViewConsumers
  extends Omit<DrawerProps, "className" | "dontShowOverlay"> {}
const defaultValue = {} as unknown as DrawerViewConsumers;
const DrawerViewContext = React.createContext(defaultValue);

export interface DrawerViewProps {
  useDrawerViewModel: () => DrawerViewModel;
}
export const DrawerView: React.FunctionComponent<DrawerViewProps> = (props) => {
  const drawerViewModel = props.useDrawerViewModel();

  const drawerViewConsumers: DrawerViewConsumers = drawerViewModel;

  return (
    <DrawerViewContext.Provider value={drawerViewConsumers}>
      <Drawer
        guid={drawerViewModel.guid}
        present={drawerViewModel.present}
        className={drawerViewModel.className}
        handleBack={drawerViewModel.handleBack}
        showBackButton={drawerViewModel.showBackButton}
        handleClose={drawerViewModel.handleClose}
        dontShowOverlay={drawerViewModel.dontShowOverlay}
      >
        {props.children || []}
      </Drawer>
    </DrawerViewContext.Provider>
  );
};

export const useDrawerViewContext = () => {
  const context = React.useContext(DrawerViewContext);
  if (context === defaultValue) {
    throw new Error("useDrawerViewContext must be used within a DrawerView");
  }
  return context;
};
